var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"usual-suppliers-wrapper"},_vm._l((_vm.suppliers),function(supply,index){return _c('LogoSupplierCard',{key:index,attrs:{"name":supply.name,"logo":supply.logo}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }